export function initScrollToTop() {
  const scrollToTopButton = document.getElementById('scrollToTopBtn');
  scrollToTopButton.addEventListener('click', scrollToTop);

  scrollToTopButton.addEventListener('keydown', function (event) {
    if (event.key === 'Enter') {
      scrollToTop();
    }
  });
}

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}
